@if (abb_medewerker) {
	<app-pasfoto [pasfotoKey]="abb_medewerker" size="size-2-5"></app-pasfoto>
}
<div class="text">
	<span class="header">{{ title }}</span>
	@if (subtitle) {
		<span class="detail">{{ subtitle }}</span>
	}
</div>
